'use strict';

angular.module('AcaApp').controller('MFAactivationController', [
  '$scope',
  '$location',
  '$window',
  'SettingsService',
  'AuthenticationService',
  'AuxiliaryDataService',
  'UserService',
  function($scope, $location, $window, SettingsService, AuthenticationService, AuxiliaryDataService, UserService){
    $scope.continueWithMFA = function(selection){
      if(selection === 'Y') {
        $location.path('/add-phone');
      } else {
        SettingsService.updateMfa('N').then(function(data){
          if(data.result.value === 'updated'){
            $window.sessionStorage.MFAEnabled = 'N';
            UserService.FindClient().then(function(data){
              $window.sessionStorage.isDemo = data.result.DataObject.IsDemoClient;
              $window.sessionStorage.userLicense = data.result.DataObject.License;
              $window.sessionStorage.cid = data.result.DataObject.CID;
              $window.sessionStorage.customerName = data.result.DataObject.Name;
              $window.sessionStorage.isManagedServices = data.result.DataObject.IsManagedServices;
            });
            $window.sessionStorage.secondsLeft = $window.sessionStorage.sessionExpireSetting;
            AuthenticationService.setSessionInterval();
            
            SettingsService.getTaxYears().then(function(data){
              $window.localStorage['TaxYears'] = data.result.value;
              $scope.taxYears = $window.localStorage['TaxYears'].split(',');
            });
            
            if($window.sessionStorage.eulaAccepted === 'false' && $window.sessionStorage.profile !== 'CNV_ACASOVOS'){
              $location.path('/license-agreement');
            }else {
              AuxiliaryDataService.LoadCountryList();
              window.location.hash = '#/home';
              $window.localStorage['FirstTimeTaxYears'] = true;
              $window.location.reload();
              AuthenticationService.checkEmailToApprove();
            }
           }
        });
      }
    }; 
  }
]);